import { Box } from '@mui/material';
import Checkbox from '../Checkbox';

const DriversCheckboxHeader = ({ isAllChecked, onToggleAll }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
    <Checkbox checked={isAllChecked} onChange={onToggleAll} />
  </Box>
);

export default DriversCheckboxHeader;
